import Types from "./Types";

const INIT_STATE = {
  scheduleByDay: {}, // day_of_week (0-6) -> Array of delivery_time_ids
  daysBySlot: {},    // delivery_time_id -> Array of day_of_weeks (0-6)
  load: null,
  error: null,
};

export function deliveryDaySlotsReducer(state = INIT_STATE, action) {
  const { type, payload, variables } = action;
  switch (type) {
    case Types.DELIVERY_DAY_SLOTS_LOADING: {
      return {
        ...state,
        load: payload,
      };
    }
    case Types.GET_DELIVERY_DAY_SLOTS_SUCCESS: {
      const schedule = { ...state.scheduleByDay };
      const scheduleList = payload?.data?.delivery_schedule || payload?.delivery_schedule || [];

      const reqDay = variables?.day_of_week;
      if (reqDay !== undefined) {
        const dayItem = scheduleList.find((item) => item?.day_of_week === reqDay);
        if (dayItem) {
          schedule[reqDay] = dayItem.delivery_time_ids || [];
        } else {
          schedule[reqDay] = [];
        }
      } else {
        scheduleList.forEach((item) => {
          const day = item?.day_of_week;
          if (day !== undefined && day !== null) {
            schedule[day] = item.delivery_time_ids || [];
          }
        });
      }

      return {
        ...state,
        scheduleByDay: schedule,
      };
    }
    case Types.GET_DELIVERY_SLOT_DAYS_SUCCESS: {
      const days = { ...state.daysBySlot };
      const reqSlotId = variables?.delivery_time_id;
      const daysList = payload?.data?.days || payload?.days || [];
      const dayOfWeeks = daysList.map((d) => (d && typeof d === "object" ? d.day_of_week : d));
      
      if (reqSlotId !== undefined) {
        days[reqSlotId] = dayOfWeeks;
      }
      return {
        ...state,
        daysBySlot: days,
      };
    }
    case Types.UPDATE_DELIVERY_DAY_SLOT_SUCCESS:
    case Types.UPDATE_DELIVERY_SLOT_DAYS_SUCCESS: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}
